module.exports = __webpack_public_path__ + "static/steps-topper-2-2ed160dcc302b99aab1a0cfe31dc8517.png";